module.exports = __webpack_public_path__ + "static/exo-drive-9bd764c020d6b8f4678172a5bbda73cd.jpg";